import React, { useState, useEffect } from 'react';
import { NavLink, Link } from 'react-router-dom';

import '../styles/Header.css';

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 450);
    };
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const closeMenu = () => setMenuOpen(false); // Optional: auto-close on link click

  return (
    <header className={`header-container${scrolled ? ' scrolled' : ''}`}>
      {/* LOGOS */}
      <div className="logo">
        <img
          src="/assets/tablogo.jpg"
          alt="GalaxyEDGE Safety Inc."
          className="tablogo-img"
        />
        <img
          src="/assets/logo updated.jpg"
          alt="GalaxyEDGE Safety Inc."
          className="tablogo_text-img"
        />
      </div>


      {/* HAMBURGER ICON (only shows on mobile) */}
      <button
        className={`menu-toggle ${menuOpen ? 'open' : ''}`}
        onClick={() => setMenuOpen(!menuOpen)}
        aria-label="Toggle menu"
      >
        <span className="bar top"></span>
        <span className="bar middle"></span>
        <span className="bar bottom"></span>
      </button>

      {/* NAVIGATION LINKS */}
      <nav className={`nav-links ${menuOpen ? 'open' : ''}`}>
        <ul>
          <li>
            <NavLink to="/home" end onClick={closeMenu}>
              Home
            </NavLink>
          </li>

          <li className="nav-item">
            <NavLink to="/about-us" end onClick={closeMenu}>
              About Us
            </NavLink>
            <ul className="dropdown">
              <li><NavLink to="/about-us" onClick={closeMenu}>Our Founder</NavLink></li>
              <li><NavLink to="/our-mission" onClick={closeMenu}>Our Vision & Mission</NavLink></li>
              <li><Link to="/our-mission" state={{ scrollDown: true }} onClick={closeMenu}>Our Core Values</Link></li>

            </ul>
          </li>

          <li className="nav-item">
            <NavLink to="/advisory" onClick={closeMenu}>
              Services
            </NavLink>
            <ul className="dropdown">
              <li><NavLink to="/prime360" onClick={closeMenu}>PRIME360™</NavLink></li>
              {/* <li>
                <NavLink
                  to="/PRIME360-form"
                  onClick={(e) => {
                    e.preventDefault();                        // stop default navigation
                    if (window.gateNav2) {
                      window.gateNav2("/PRIME360-form");       // gate using slot #2
                    } else {
                      window.location.href = "/PRIME360-form"; // fallback if gateNav not ready
                    }
                    closeMenu && closeMenu();
                  }}
                >
                  PRIME360™ form
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/TargetedOHS"
                  onClick={(e) => {
                    e.preventDefault();                 // stop immediate navigation
                    if (window.gateNav1) {
                      window.gateNav1("/TargetedOHS");  // opens Terms first if not accepted
                    } else {
                      window.location.href = "/TargetedOHS"; // fallback
                    }
                    closeMenu && closeMenu();
                  }}
                >
                  Targeted OHS Form
                </NavLink>
              </li> */}
            </ul>
          </li>


          <li className="nav-item">
            <NavLink to="/training" onClick={closeMenu}>
              Training
            </NavLink>
            <ul className="dropdown">
              <li><NavLink to="/Immersive-Learning" onClick={closeMenu}>Immersive-Learning</NavLink></li>
              {/* <li>
                <NavLink
                  to="/ImmersiveLearningDevelopmentConsultationForm"
                  onClick={(e) => {
                    e.preventDefault(); // stop immediate navigation
                    if (window.gateNav3) {
                      window.gateNav3("/ImmersiveLearningDevelopmentConsultationForm"); // open Terms first if needed
                    } else {
                      window.location.href = "/ImmersiveLearningDevelopmentConsultationForm"; // fallback
                    }
                    closeMenu && closeMenu();
                  }}
                >
                  Immersive Learning Form
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/TrainingDesignForm"
                  onClick={(e) => {
                    e.preventDefault(); // stop immediate navigation
                    if (window.gateNav3) {
                      window.gateNav3("/TrainingDesignForm"); // open Terms first if needed
                    } else {
                      window.location.href = "/TrainingDesignForm"; // fallback
                    }
                    closeMenu && closeMenu();
                  }}
                >
                  Training Design Form
                </NavLink>
              </li> */}
            </ul>
            
            
          </li>

          <li>
            <NavLink to="/ai-driven-safety-solutions" onClick={closeMenu}>
              AI & Tech
            </NavLink>
          </li>

          <li className="nav-item">
            <NavLink to="/EventsCultureShifts" onClick={closeMenu}>
              Events
            </NavLink>
            {/* <ul className="dropdown">
              <li><NavLink to="/news" onClick={closeMenu}>News</NavLink></li>
            </ul> */}
          </li>

          <li className="nav-item">
            <NavLink to="/partnerships" onClick={closeMenu}>
              Partnerships
            </NavLink>
            <ul className="dropdown">
            <li>
              <NavLink
                to="/GlobalMovementForm"
                onClick={(e) => {
                  e.preventDefault(); // stop immediate navigation
                  if (window.gateNav4) {
                    window.gateNav4("/GlobalMovementForm"); // open Terms first if needed
                  } else {
                    window.location.href = "/GlobalMovementForm"; // fallback
                  }
                  closeMenu && closeMenu();
                }}
              >
                Global Task
              </NavLink>
            </li>
            </ul>
          </li>
        </ul>
      </nav>
    </header>
  );
}
